module.exports = __webpack_public_path__ + "img/DNARepair-CRC_GSE225857.d96c5706.png";